import { isValidLocation } from '@/utils/types';
import { useSearchParams } from 'react-router-dom';

export const useLocationParam = () => {
  const [searchParams] = useSearchParams();
  // default to telemedicine if no location or invalid location provided
  const locationParam = searchParams.get('location') || '';
  const location = isValidLocation(locationParam)
    ? locationParam
    : 'telemedicine';

  return location;
};
